import AvatarCustom from "./avatar-custom";

export default AvatarCustom;